import { Component, ComponentRef, inject, OnDestroy, OnInit, viewChild, ViewContainerRef } from '@angular/core'
import { Observable, Subscription, map } from 'rxjs'
import { PageContent } from '../../shared/intefaces/interfaces'
import { CustomContent } from '../../shared/services/custom-content/custom-content'
import { SeoService } from '../../shared/services/seo/seo-service'
import { AsyncPipe } from '@angular/common'
import { SharedContent } from '../../shared/services/shared-content/shared-content'

@Component({
	selector: 'app-home',
	imports: [AsyncPipe],
	templateUrl: './home.html',
	styleUrl: './home.css',
})
export class Home implements OnInit, OnDestroy {
	viewContainer = inject(ViewContainerRef)
	container = viewChild.required('container', {
		read: ViewContainerRef,
	})

	$pageContent!: Observable<PageContent | undefined>
	urlSubscription!: Subscription

	private customContentService = inject(CustomContent)
	private sharedContentService = inject(SharedContent)
	private seoService = inject(SeoService)

	ngOnInit(): void {
		this.$pageContent = this.customContentService.getPageContent('home').pipe(
			map((resp) => {
				if (!resp) return // display 404 or home page?
				this.sharedContentService.setPhoneNumber(resp.phoneNumber)
				this.seoService.setCanonicalURL()
				this.seoService.setPageMetaData(resp.title, resp.description)

				this.viewContainer.clear()
				Object.entries(resp.content).forEach((key) => {
					this.loadComponent(key[1])
				})

				return resp
			}),
		)
	}

	loadComponent(key: any) {
		const componentType = this.customContentService.mapToComponentType(key.sharedComponentName)

		if (!componentType) return
		const componentRef: ComponentRef<any> = this.viewContainer.createComponent(componentType)

		// Set inputs for the dynamically created component
		componentRef.instance.content = key
	}

	ngOnDestroy(): void {
		this.viewContainer?.clear()
		this.urlSubscription?.unsubscribe()
	}
}
